// Respect every existing Core profile; only a first visit gets Caroline's
// Portuguese default. Read before Core initializes/writes a new profile.
const isFirstVisit = (storage) => {
    try { return storage.getItem('profile') === null; }
    catch (_) { return false; }
};
const isFirstBrowserVisit = () => {
    try { return isFirstVisit(window.localStorage); }
    catch (_) { return false; }
};
module.exports = { isFirstVisit, isFirstBrowserVisit };
